import {Axios} from "../../../axiosHelper";
import {AxiosError, AxiosResponse} from "axios";
import {deviceActions} from "../../slice/efe/deviceSlice";
import {DeviceListResponse} from "../../data/device";

export const getDeviceList = (companyId: number): any => {
    return async (dispatch: any) => {
        dispatch(deviceActions.setLoading(true));

        Axios.get(`efe/device/list?companyId=${companyId}`)
            .then((res: AxiosResponse<DeviceListResponse>) => {
                dispatch(deviceActions.setDeviceList(res.data.deviceList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(deviceActions.setError(resp));
                    }
                }
            });
    };
};

export const getUnassignedDeviceList = (companyId: number): any => {
    return async (dispatch: any) => {
        dispatch(deviceActions.setLoading(true));

        Axios.get(`efe/device/unassigned/list?companyId=${companyId}`)
            .then((res: AxiosResponse<DeviceListResponse>) => {
                dispatch(deviceActions.setDeviceList(res.data.deviceList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(deviceActions.setError(resp));
                    }
                }
            });
    };
};

export const clearDeviceResponse = (): any => {
    return async (dispatch: any) => {
        dispatch(deviceActions.setResponse(null));
    };
};

export const clearDeviceError = (): any => {
    return async (dispatch: any) => {
        dispatch(deviceActions.setError(null));
    };
};